import _ from 'underscore';

const scope = '@scroll-shadow-fn';

const epsilon = 1;

export default {
  inserted(el) {
    const checkFn = _.debounce(() => {
      el.classList.remove('is-scroll-shadow-at-top');
      el.classList.remove('is-scroll-shadow-at-middle');
      el.classList.remove('is-scroll-shadow-at-bottom');
      if (el.scrollHeight > el.clientHeight) {
        const bottomDelta = Math.abs(el.clientHeight + el.scrollTop - el.scrollHeight);
        const atTop = el.scrollTop === 0;
        const atBottom = bottomDelta <= epsilon;
        const atMiddle = !atTop && !atBottom;
        if (atTop) {
          el.classList.add('is-scroll-shadow-at-top');
        }
        if (atBottom) {
          el.classList.add('is-scroll-shadow-at-bottom');
        }
        if (atMiddle) {
          el.classList.add('is-scroll-shadow-at-middle');
        }
        // $(el).find('.scroll-shadow-container').css('top', `${el.offsetTop + $(el).height()}px`);
        const height = parseFloat(getComputedStyle(el, null).height.replace('px', ''));
        const containerRef = el.querySelector('.scroll-shadow-container');
        containerRef.style.top = `${el.offsetTop + height}px`;
      }
    }, 50);
    // $(el).prepend("<div class='scroll-shadow-container'></div>");
    const child = document.createElement('div');
    child.className = 'scroll-shadow-container';
    el.insertBefore(child, el.firstChild);

    checkFn();

    el.addEventListener('scroll', checkFn, true);
    /*  passive = true
            (https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#improving_scrolling_performance_with_passive_listeners)
        */
    const ro = new ResizeObserver(checkFn);
    ro.observe(el);

    // eslint-disable-next-line no-param-reassign
    el[scope] = {
      scrollListener: checkFn,
      resizeObserver: ro,
    };
  },
  unbind(el) {
    if (el[scope]) {
      el.removeEventListener('scroll', el[scope].scrollListener);
      el[scope].resizeObserver.unobserve(el);
      el[scope].resizeObserver.disconnect();
      // eslint-disable-next-line no-param-reassign
      delete el[scope];
    }
  },
};
